import React from 'react'
import { IconId, iconMap } from './generatedIconMap'
import styled, { css, FlattenSimpleInterpolation } from 'styled-components'

export const iconIdList = IconId.options.map((icon) => icon.value)

export type IconSize = 'size-12' | 'size-16' | 'size-18' | 'size-20' | 'size-24' | 'size-36' | 'size-56' 

export interface IIconProps {
  iconId :    IconId,
  size?:      IconSize,
  className?: string,
  color?:     string,
  onClick?:   (e: React.MouseEvent<HTMLElement>) => void,
}

const calcSize = ({
  size,
}: Omit<IIconProps, 'iconId'>): FlattenSimpleInterpolation => {
  const iconSize = (() => {
    switch (size) {
      case 'size-56':
        return '5.6rem'
      case 'size-36':
        return '3.6rem'
      case 'size-24':
        return '2.4rem'
      case 'size-20':
        return '2rem'
      case 'size-12':
        return '1.2rem'
      case 'size-18':
        return '1.8rem'
      case 'size-16':
      default:
        return '1.6rem'
    }
  })()

  return css`
    width: ${iconSize};
    height: ${iconSize};
  `
}

const IconWrapper = styled.span<Omit<IIconProps, 'iconId'>>`
  display:         inline-flex;
  flex-direction:  row;
  justify-content: center;
  align-items:     center;
  overflow:        visible;
  color:           ${props => props.color || "inherit"};
  ${calcSize}

  & svg {
    display: block;
    width: 100%;
    object-fit: cover;

    ${calcSize}
  }
`

export const Icon = React.forwardRef<
  HTMLSpanElement,
  IIconProps & { contentEditable?: boolean | 'inherit' }
>(({ iconId, contentEditable = false, ...props }, ref) => {
  const SvgIcon = iconMap[iconId];

  return (
    <IconWrapper {...props} contentEditable={contentEditable} ref={ref}>
      <SvgIcon color={props.color} />
    </IconWrapper>
  )
})
